import {getCookie} from '../../utils/cookies'
import {appLockedAnchorDealImpressionsCountConfig} from './cookieConfig'

/**
 * Gets the app locked anchor deal impressions count from cookies.
 * @returns The impressions count as a number
 */
export const getAppLockedAnchorDealImpressionsCount = () =>
  Number(getCookie(appLockedAnchorDealImpressionsCountConfig.name))
